import { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';

const useInactivityTimer = (timeoutMinutes) => {
  const navigate = useNavigate();
  const timerRef = useRef(null);
  const envMinutes = parseInt(process.env.REACT_APP_INACTIVITY_MINUTES, 10);
  const minutes = timeoutMinutes || (!isNaN(envMinutes) ? envMinutes : 20);

  const timeout = minutes * 60 * 1000;

  const endSession = async () => {
    try {
      await fetch('/kidlab-reg/admin/logout', { method: 'POST', credentials: 'include' });
    } catch (err) {
      console.error('Logout API failed:', err);
    }

    sessionStorage.clear();
    localStorage.removeItem('authToken');

    alert('You have been logged out due to inactivity.');
    navigate('/login');
  };

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(endSession, timeout);
  };

  useEffect(() => {
    const events = [
      'mousemove',
      'mousedown',
      'keydown',
      'scroll',
      'touchstart',
    ];

    events.forEach((event) => window.addEventListener(event, resetTimer));

    resetTimer(); // Start timer initially

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetTimer));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, []);
};

export default useInactivityTimer;
